(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-avisconfort"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-clientes')) {
    customElements.define('lomea-clientes', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.lomea-clientes__track');

        this.onKey = event => {
          if (
            event.target !== this.track ||
            event.altKey ||
            event.ctrlKey ||
            event.metaKey
          ) return;

          if (
            !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
          ) return;

          event.preventDefault();

          const behavior =
            matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth';

          if (event.key === 'Home' || event.key === 'End') {
            this.track.scrollTo({
              left: event.key === 'Home' ? 0 : this.track.scrollWidth,
              behavior
            });
          } else {
            if (!this.track.children.length) return;

            const gap =
              parseFloat(getComputedStyle(this.track).columnGap) || 0;

            const step =
              this.track.children[0].getBoundingClientRect().width + gap;

            this.track.scrollBy({
              left: (event.key === 'ArrowLeft' ? -1 : 1) * step,
              behavior
            });
          }
        };

        this.track.addEventListener('keydown', this.onKey);
      }

      disconnectedCallback() {
        this.track.removeEventListener('keydown', this.onKey);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-bienetretenu"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-allure')) {
    customElements.define('lomea-allure', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          if (!event.target.closest('[data-la-atc]')) return;

          const selectors = [
            'product-info product-form button[name="add"]',
            'button[id^="ProductSubmitButton-"]',
            'form[action*="/cart/add"] button[name="add"]',
            'form[action*="/cart/add"] [type="submit"]'
          ];

          const scope = document.querySelector('main') || document;
          let target;

          for (const selector of selectors) {
            target = [...scope.querySelectorAll(selector)].find(
              el => el.getClientRects().length
            );

            if (target) break;
          }

          target = target || scope.querySelector('product-info');

          if (!target) return;

          target.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth',
            block: 'center'
          });

          if (!target.disabled) {
            target.focus({ preventScroll: true });
          }
        };

        this.addEventListener('click', this.onClick);

        const video = this.querySelector('video');

        if (video) {
          this.startVideo = () => {
            video.muted = true;
            video.defaultMuted = true;
            video.loop = true;
            video.autoplay = true;
            video.playsInline = true;
            video.controls = false;
            video.removeAttribute('controls');

            const playback = video.play();

            if (playback) {
              playback.catch(() => {});
            }
          };

          video.addEventListener('loadeddata', this.startVideo);
          video.addEventListener('canplay', this.startVideo);
          this.startVideo();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);

        const video = this.querySelector('video');

        if (video && this.startVideo) {
          video.removeEventListener('loadeddata', this.startVideo);
          video.removeEventListener('canplay', this.startVideo);
          video.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-confortcourse"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-confort')) {
    customElements.define(
      'lomea-confort',
      class extends HTMLElement {
        connectedCallback() {
          this.prepareVideos = () => {
            this.querySelectorAll('video').forEach(video => {
              const autoplay = this.dataset.autoplay === 'true';

              video.controls = this.dataset.controls === 'true';
              video.loop = this.dataset.loop === 'true';
              video.muted = true;
              video.defaultMuted = true;
              video.autoplay = autoplay;
              video.playsInline = true;

              video.setAttribute('muted', '');
              video.setAttribute('playsinline', '');

              if (!video.controls) {
                video.removeAttribute('controls');
              }

              if (autoplay && video.paused) {
                const playback = video.play();

                if (playback && playback.catch) {
                  playback.catch(() => {});
                }
              }
            });
          };

          this.prepareVideos();

          this.addEventListener(
            'loadeddata',
            this.prepareVideos,
            true
          );

          this.addEventListener(
            'canplay',
            this.prepareVideos,
            true
          );

          this.observer = new MutationObserver(
            this.prepareVideos
          );

          this.observer.observe(this, {
            childList: true,
            subtree: true
          });
        }

        disconnectedCallback() {
          this.removeEventListener(
            'loadeddata',
            this.prepareVideos,
            true
          );

          this.removeEventListener(
            'canplay',
            this.prepareVideos,
            true
          );

          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-detailshort"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-details')) {
    customElements.define(
      'lomea-details',
      class extends HTMLElement {
        connectedCallback() {
          this.startVideos = () => {
            this.querySelectorAll('video').forEach(video => {
              video.controls = false;
              video.removeAttribute('controls');

              video.muted = true;
              video.defaultMuted = true;
              video.autoplay = true;
              video.loop = true;
              video.playsInline = true;

              video.setAttribute('muted', '');
              video.setAttribute('autoplay', '');
              video.setAttribute('loop', '');
              video.setAttribute('playsinline', '');

              if (video.paused) {
                const playback = video.play();

                if (playback && playback.catch) {
                  playback.catch(() => {});
                }
              }
            });
          };

          this.startVideos();

          this.addEventListener(
            'loadeddata',
            this.startVideos,
            true
          );

          this.addEventListener(
            'canplay',
            this.startVideos,
            true
          );

          this.observer = new MutationObserver(
            this.startVideos
          );

          this.observer.observe(this, {
            childList: true,
            subtree: true
          });
        }

        disconnectedCallback() {
          this.removeEventListener(
            'loadeddata',
            this.startVideos,
            true
          );

          this.removeEventListener(
            'canplay',
            this.startVideos,
            true
          );

          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-faq')) {
    customElements.define(
      'lomea-faq',
      class extends HTMLElement {
        connectedCallback() {
          this.handleToggle = event => {
            const item = event.target;

            if (
              !this.hasAttribute('data-single-open') ||
              item.tagName !== 'DETAILS' ||
              !item.open
            ) {
              return;
            }

            this.querySelectorAll('details').forEach(other => {
              if (other !== item) {
                other.open = false;
              }
            });
          };

          this.addEventListener(
            'toggle',
            this.handleToggle,
            true
          );
        }

        disconnectedCallback() {
          this.removeEventListener(
            'toggle',
            this.handleToggle,
            true
          );
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-faqq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-faq')) {
    customElements.define('lomea-faq', class extends HTMLElement {
      connectedCallback() {
        this.handleToggle = event => {
          const item = event.target;

          if (
            !this.hasAttribute('data-single-open') ||
            item.tagName !== 'DETAILS' ||
            !item.open
          ) return;

          this.querySelectorAll('details').forEach(other => {
            if (other !== item) {
              other.open = false;
            }
          });
        };

        this.addEventListener('toggle', this.handleToggle, true);
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.handleToggle, true);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-poche"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-poches')) {
    customElements.define('lomea-poches', class extends HTMLElement {
      connectedCallback() {
        this.onClick = (event) => {
          if (!event.target.closest('[data-lp-atc]')) return;

          const selectors = [
            'product-info product-form button[name="add"]',
            'button[id^="ProductSubmitButton-"]',
            'form[action*="/cart/add"] button[name="add"]',
            'form[action*="/cart/add"] [type="submit"]'
          ];

          const scope = document.querySelector('main') || document;
          let target;

          for (const selector of selectors) {
            target = [...scope.querySelectorAll(selector)].find(
              el => el.getClientRects().length
            );

            if (target) break;
          }

          target = target || scope.querySelector('product-info');

          if (!target) return;

          target.scrollIntoView({
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth',
            block: 'center'
          });

          if (!target.disabled) {
            target.focus({ preventScroll: true });
          }
        };

        this.addEventListener('click', this.onClick);

        const video = this.querySelector('video');

        if (video) {
          this.startVideo = () => {
            video.muted = true;
            video.defaultMuted = true;
            video.loop = true;
            video.autoplay = true;
            video.playsInline = true;
            video.controls = false;
            video.removeAttribute('controls');

            const playback = video.play();

            if (playback) {
              playback.catch(() => {});
            }
          };

          video.addEventListener('loadeddata', this.startVideo);
          video.addEventListener('canplay', this.startVideo);
          this.startVideo();
        }
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);

        const video = this.querySelector('video');

        if (video && this.startVideo) {
          video.removeEventListener('loadeddata', this.startVideo);
          video.removeEventListener('canplay', this.startVideo);
          video.pause();
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-shortmonte"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-rythme')) {
    customElements.define(
      'lomea-rythme',
      class extends HTMLElement {
        connectedCallback() {
          this.prepareVideos = () => {
            this.querySelectorAll('video').forEach(video => {
              video.muted = true;
              video.defaultMuted = true;
              video.playsInline = true;
              video.autoplay = this.dataset.autoplay === 'true';
              video.loop = this.dataset.loop === 'true';
              video.controls = this.dataset.controls === 'true';

              video.setAttribute('muted', '');
              video.setAttribute('playsinline', '');

              if (!video.controls) {
                video.removeAttribute('controls');
              }

              if (video.autoplay && video.paused) {
                const play = video.play();

                if (play && play.catch) {
                  play.catch(() => {});
                }
              }
            });
          };

          this.returnToAtc = event => {
            if (!event.target.closest('[data-return-atc]')) {
              return;
            }

            const scope = document.querySelector('main') || document;

            const selectors = [
              'product-info product-form button[name="add"]',
              'button[id^="ProductSubmitButton-"]',
              'form[action*="/cart/add"] button[name="add"]',
              'form[action*="/cart/add"] [type="submit"]'
            ];

            let target;

            for (const selector of selectors) {
              target = Array.from(
                scope.querySelectorAll(selector)
              ).find(element => element.getClientRects().length);

              if (target) {
                break;
              }
            }

            target = target || scope.querySelector('product-info');

            if (!target) {
              return;
            }

            const reduceMotion = window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

            target.scrollIntoView({
              behavior: reduceMotion ? 'auto' : 'smooth',
              block: 'center'
            });

            if (!target.disabled) {
              target.focus({ preventScroll: true });
            }
          };

          this.prepareVideos();

          this.addEventListener('click', this.returnToAtc);
          this.addEventListener('loadeddata', this.prepareVideos, true);
          this.addEventListener('canplay', this.prepareVideos, true);

          this.observer = new MutationObserver(this.prepareVideos);

          this.observer.observe(this, {
            childList: true,
            subtree: true
          });
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.returnToAtc);
          this.removeEventListener('loadeddata', this.prepareVideos, true);
          this.removeEventListener('canplay', this.prepareVideos, true);
          this.observer?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lomea-votrechois"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lomea-confiance-choix')) {
    customElements.define(
      'lomea-confiance-choix',
      class extends HTMLElement {
        connectedCallback() {
          this.onClick = event => {
            const button = event.target.closest('[data-lx-guide]');

            if (!button) return;

            const status = this.querySelector('.lomea-choix__status');
            status.hidden = true;

            const dialog = document.querySelector(
              'dialog.lomea-guide__fenetre'
            );

            if (dialog && typeof dialog.showModal === 'function') {
              if (!dialog.open) {
                dialog.showModal();
              }

              const close = dialog.querySelector('[autofocus], button');

              if (close) {
                close.focus();
              }

              dialog.addEventListener(
                'close',
                () => button.focus({ preventScroll: true }),
                { once: true }
              );
            } else if (this.dataset.guideUrl) {
              window.location.assign(this.dataset.guideUrl);
            } else {
              status.hidden = false;
            }
          };

          this.addEventListener('click', this.onClick);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this.onClick);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
